import { Text } from '../../..'
import { useComplianceData } from '../../../../services/mlsComplianceDataService'
import { ListingDetailsListing } from '../../../../types/listings'

type ListingRequiredFields = Pick<
  ListingDetailsListing,
  'mlsNumber' | 'source' | 'originatingSystemName'
>
interface MlsAbbrevAndNumberProps {
  listing: ListingRequiredFields
  className?: string
}

export const MlsAbbrevAndNumber = ({
  listing,
  className,
}: MlsAbbrevAndNumberProps) => {
  // disclaimer isn't available in listings list view, and it isn't needed, so we just pass an empty string
  const complianceData = useComplianceData({ ...listing, disclaimer: '' })

  return (
    <Text
      data-qa='mlsAbbrevAndNumberText'
      element='div'
      size='smallest'
      variant='neutralCool'
      variantCount='500'
      className={className}
    >
      {complianceData?.mlsAbbreviation
        ? `${complianceData?.mlsAbbreviation} · ` // only render middot if abbreviation is present
        : ''}

      {`MLS #${listing?.mlsNumber}`}
    </Text>
  )
}
